import { selectProfile } from '../../../../../store/workspace/selectors';
import EmptyState from '../../components/EmptyState';
import { useSelector } from '../../../../../store/store';
import { PLANS_TABS } from '../../constants';
import styles from './style.module.scss';
import { useMemo, useState } from 'react';
import { PlansTab } from '../../types';
import PlanCard from './PlanCard';

/** The plan the account is on today, plus every plan it was on before. */
function PlanInformation() {
    const profile = useSelector(selectProfile);
    const [openedPlans, setOpenedPlans] = useState<string[]>([]);
    const [plansTab, setPlansTab] = useState<PlansTab>('Current');

    /** The API appends plans chronologically, so the last one is the active one. */
    const plansList = useMemo(() => {
        const plans = profile?.userPlan;
        if (!plans) return plans;

        return plansTab === 'Current' ? plans.slice(-1) : plans.slice(0, plans.length - 1);
    }, [profile?.userPlan, plansTab]);

    const changePlansTab = (tab: PlansTab) => {
        setOpenedPlans([]);
        setPlansTab(tab);
    };

    const togglePlanDetail = (key: string) => {
        setOpenedPlans(prev => prev.includes(key)
            ? prev.filter(item => item !== key)
            : [...prev, key]);
    };

    return (
        <div className={styles.plan_info}>
            <span className={styles.plan_info_title}>
                Plan Information
            </span>

            <div className={styles.plan_info_tab}>
                {PLANS_TABS.map(tab => <div
                    key={tab.id}
                    className={styles.plan_info_tab_item}
                    onClick={() => changePlansTab(tab.id)}
                    data-is-active={plansTab === tab.id}
                >
                    <span>{tab.title}</span>
                </div>)}
            </div>

            <div className={styles.plan_info_list}>
                {plansList && plansList.length > 0
                    ? plansList.map((plan, index) => {
                        const key = `${plan.modify}-${index}`;

                        return (
                            <PlanCard
                                key={key}
                                plan={plan}
                                isDetailShow={openedPlans.includes(key)}
                                isCurrentPlan={plansTab === 'Current'}
                                toggleDetail={() => togglePlanDetail(key)}
                            />
                        );
                    })
                    : <EmptyState />}
            </div>
        </div>
    );
};

export default PlanInformation;
